import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';

import InputSearch from "../../ui/InputSearch/InputSearch";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";
import LocalizationItem from './LocalizationItem/LocalizationItem'

import {
  changeLocalizationsPage,
  changeLocalizationsLimit,
  getLocalizationsListAsync,
  changeLocalizationsSearch,
  startLocalizationsSearch,
  clearLocalizationsSearch, changeLocalizationAsync,
} from '../../../redux/actions/localizationsList'

import { setListsPayload } from '../../../methods';
import {
  openChangeLocaleModal,
  closeChangeLocaleModal,
  openFiltersModal,
  closeFiltersModal,
} from '../../../redux/actions/ui'
import Modal from "../../ui/Modals/ModalWindow";
import FiltersModal from '../../ui/Modals/FiltersModal'

const mapStateToProps = state => ({
  ...state.localizationsList,
  changeLocaleModal: state.ui.changeLocaleModal,
  filtersModal: state.ui.filtersModal,
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changeLocalizationsPage(page)),
  onChangeDisplayOption: limit => dispatch(changeLocalizationsLimit(limit)),
  getLocalizationsList: payload => dispatch(getLocalizationsListAsync(payload)),
  changeLocalization: (payload) => dispatch(changeLocalizationAsync(payload)),
  changeLocalizationsSearch: value => dispatch(changeLocalizationsSearch(value)),
  startLocalizationsSearch: value => dispatch(startLocalizationsSearch(value)),
  clearLocalizationsSearch: () => dispatch(clearLocalizationsSearch()),
  openChangeLocaleModal: () => dispatch(openChangeLocaleModal()),
  closeChangeLocaleModal: () => dispatch(closeChangeLocaleModal()),
  openFiltersModal: () => dispatch(openFiltersModal()),
  closeFiltersModal: () => dispatch(closeFiltersModal()),
});

class LocalizationsList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    loadingChange: PropTypes.bool.isRequired,
    localizations: PropTypes.object.isRequired,
    langMap: PropTypes.object.isRequired,
    local_total: PropTypes.number.isRequired,
    local_limit: PropTypes.number.isRequired,
    local_activePage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    getLocalizationsList: PropTypes.func.isRequired,
    changeLocalization: PropTypes.func.isRequired,
    //Модалка
    changeLocaleModal: PropTypes.object.isRequired,
    openChangeLocaleModal: PropTypes.func.isRequired,
    closeChangeLocaleModal: PropTypes.func.isRequired,
    filtersModal: PropTypes.object.isRequired,
    openFiltersModal: PropTypes.func.isRequired,
    closeFiltersModal: PropTypes.func.isRequired,
    //Поиск
    changeLocalizationsSearch: PropTypes.func.isRequired,
    startLocalizationsSearch: PropTypes.func.isRequired,
    clearLocalizationsSearch: PropTypes.func.isRequired,
    local_search: PropTypes.string.isRequired,
    local_activeSearch: PropTypes.string.isRequired,
    sorting: PropTypes.object.isRequired,
  };

  state = {
    activeUpdatingItem: null,
    langFilter: [],
  }


  componentDidMount = () => {
    const { getLocalizationsList, local_limit, local_activePage, local_activeSearch, sorting } = this.props;
    const payload = setListsPayload(local_limit, local_activePage, local_activeSearch, sorting);
    getLocalizationsList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { local_limit, local_activePage, local_activeSearch, getLocalizationsList, sorting } = this.props;
    const payload = setListsPayload(local_limit, local_activePage, local_activeSearch, sorting);

    if (this.state.langFilter.length !== 0) payload.lang = this.state.langFilter

    //Условия перезагрузки
    if (
      (previousProps.local_activePage !== local_activePage)
      || (previousProps.local_limit !== local_limit)
      || ((previousProps.local_activeSearch !== local_activeSearch))
    ) getLocalizationsList(payload);
  }


  startLocalizationsSearching = (value) => {
    const { local_search, startLocalizationsSearch } = this.props;
    //В строке поиска должен быть хотя бы один символ
    if ((value === 'Enter') && (local_search.length !== 0)){
      startLocalizationsSearch(local_search);
    }
  }

  filterSubmit = () => {
    const { local_limit, local_activePage, local_activeSearch, sorting, getLocalizationsList } = this.props;
    const payload = setListsPayload(local_limit, local_activePage, local_activeSearch, sorting);

    if (this.state.langFilter.length !== 0) payload.lang = this.state.langFilter

    this.props.closeFiltersModal();
    getLocalizationsList(payload);
  }


  //ПОИСК
  //Здесь поиск ведется по ID
  //Оставляем только цифры, латинские буквы и символы для email
  onChangeLocalizationsSearch = (value) => {
    const { changeLocalizationsSearch, clearLocalizationsSearch } = this.props;
    (value.length !== 0) ? changeLocalizationsSearch(value) : clearLocalizationsSearch();
  }

  onLocalizationItemSubmit = (id, value) => {
    this.setState(() => ({
      activeUpdatingItem: id && value ? { id, value } : null
    }))

    this.props.openChangeLocaleModal();
  }

  onLocalizationItemReset = (id) => {
    this.setState(() => ({
      activeUpdatingItem: id ? { id } : null
    }))
  }

  onChangeLocalModalSubmit = () => {
    this.props.changeLocalization(this.state.activeUpdatingItem);
  }

  onFilterChange = (lang) => {
    this.setState((prevState) => ({
      ...prevState,
      langFilter: prevState.langFilter.includes(lang)
          ? prevState.langFilter.filter(item => item !== lang)
          : [...prevState.langFilter, lang]
    }))
  }

  onFilterReset = () => this.setState(
      (prevState) => ({ ...prevState, langFilter: [] }),
      this.filterSubmit
  )

  onFilterSubmit = () => this.filterSubmit()


  render() {
    const {
      ready, loading, loadingChange, localizations, local_limit, local_total, local_activePage, onChangePage, onChangeDisplayOption, local_search, clearLocalizationsSearch,
      changeLocaleModal, closeChangeLocaleModal,
      filtersModal, openFiltersModal, closeFiltersModal, langMap
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(local_total / local_limit);

    const filterBtnClasses = classnames({
      'btn-white': true,
      'btn-white--with-badge': this.state.langFilter.length !== 0,
    })

    return(
      <div className="lists-wrap">
        <div>{ changeLocaleModal.isOpen }</div>
        <div className="lists-header">
            <InputSearch
                placeholder="Поиск по ID"
                value={local_search}
                onChange={this.onChangeLocalizationsSearch}
                onKeyUp={this.startLocalizationsSearching}
                onClear={clearLocalizationsSearch}
            />
        </div>
        {
            ready && <React.Fragment>
              <div className="lists-content localizations">
                <div className="lists-content-total lists-content-total--with-btn">
                  Ключи ({local_total})
                  <button type="button" className={filterBtnClasses} onClick={openFiltersModal}>
                    <i aria-hidden="true" className="icon">
                      <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.28887 11.2499C7.89833 11.2498 8.49001 11.4553 8.9683 11.833C9.44659 12.2107 9.78354 12.7387 9.9247 13.3316L17.7055 13.3333C17.8639 13.3333 18.0163 13.3935 18.132 13.5016C18.2477 13.6097 18.3181 13.7577 18.3289 13.9157C18.3397 14.0736 18.2901 14.2298 18.1902 14.3527C18.0902 14.4755 17.9474 14.5558 17.7905 14.5774L17.7055 14.5833H9.9247C9.78382 15.1764 9.44698 15.7047 8.96867 16.0827C8.49036 16.4607 7.89852 16.6663 7.28887 16.6663C6.67922 16.6663 6.08739 16.4607 5.60907 16.0827C5.13076 15.7047 4.79393 15.1764 4.65304 14.5833H2.28887C2.13052 14.5832 1.97809 14.523 1.86238 14.4149C1.74667 14.3068 1.67631 14.1588 1.66552 14.0009C1.65472 13.8429 1.7043 13.6867 1.80423 13.5638C1.90416 13.441 2.047 13.3607 2.20387 13.3391L2.28887 13.3333H4.65304C4.79388 12.7401 5.13069 12.2117 5.60901 11.8337C6.08733 11.4556 6.67919 11.2499 7.28887 11.2499ZM7.28887 12.4999C6.98646 12.4999 6.69152 12.5939 6.44488 12.7688C6.19823 12.9438 6.01209 13.1911 5.91221 13.4766L5.89471 13.5291L5.86221 13.6524C5.8144 13.877 5.82011 14.1096 5.87887 14.3316L5.91221 14.4399L5.93304 14.4974C6.04256 14.7741 6.23411 15.0107 6.48198 15.1754C6.72985 15.3401 7.02217 15.425 7.31969 15.4187C7.61722 15.4125 7.9057 15.3153 8.14643 15.1404C8.38715 14.9654 8.56858 14.721 8.66637 14.4399L8.6997 14.3316L8.68471 14.3816C8.7514 14.1615 8.7651 13.9288 8.7247 13.7024L8.6997 13.5883L8.68304 13.5299L8.64387 13.4183C8.53582 13.1472 8.34893 12.9148 8.10737 12.751C7.8658 12.5873 7.58068 12.4999 7.28887 12.4999ZM12.7055 3.33325C13.3152 3.33326 13.9071 3.53893 14.3854 3.91699C14.8637 4.29504 15.2005 4.82339 15.3414 5.41659H17.7055C17.8639 5.41663 18.0163 5.47679 18.132 5.5849C18.2477 5.693 18.3181 5.841 18.3289 5.99899C18.3397 6.15697 18.2901 6.31316 18.1902 6.436C18.0902 6.55884 17.9474 6.63917 17.7905 6.66075L17.7055 6.66659H15.3414C15.2005 7.25974 14.8637 7.78803 14.3853 8.16604C13.907 8.54405 13.3152 8.74968 12.7055 8.74968C12.0959 8.74968 11.5041 8.54405 11.0257 8.16604C10.5474 7.78803 10.2106 7.25974 10.0697 6.66659H2.28887C2.13052 6.66654 1.97809 6.60638 1.86238 6.49827C1.74667 6.39017 1.67631 6.24217 1.66552 6.08419C1.65472 5.9262 1.7043 5.77001 1.80423 5.64717C1.90416 5.52433 2.047 5.444 2.20387 5.42242L2.28887 5.41659L10.0697 5.41492C10.2109 4.82203 10.5478 4.29406 11.0261 3.91633C11.5044 3.5386 12.0961 3.33318 12.7055 3.33325ZM12.7055 4.58325C12.403 4.58328 12.108 4.67737 11.8614 4.85251C11.6147 5.02765 11.4286 5.27516 11.3289 5.56075L11.3114 5.61242L11.2797 5.73575C11.2317 5.96025 11.2371 6.1929 11.2955 6.41492L11.3289 6.52325L11.3497 6.58075C11.4591 6.85748 11.6506 7.09411 11.8984 7.25887C12.1463 7.42363 12.4385 7.50863 12.7361 7.50246C13.0336 7.49629 13.3221 7.39925 13.5629 7.22436C13.8037 7.04948 13.9852 6.80511 14.083 6.52409L14.1164 6.41492L14.1014 6.46492C14.1681 6.24485 14.1818 6.01213 14.1414 5.78575L14.1164 5.67159L14.0997 5.61325L14.0605 5.50159C13.9525 5.23052 13.7656 4.9981 13.524 4.83438C13.2825 4.67067 12.9974 4.58319 12.7055 4.58325Z"/>
                      </svg>
                    </i>
                    Фильтры
                  </button>
                  <FiltersModal
                      availableFilters={Object.entries(langMap).map(([key, value]) => ({ label: value, value: key }))}
                      selectedFilters={this.state.langFilter}
                      modal={filtersModal}
                      onSubmit={this.onFilterSubmit}
                      onCancel={closeFiltersModal}
                      onReset={this.onFilterReset}
                      onToggleFilter={this.onFilterChange}
                  />
                </div>
                <div className="localizations__list">
                  {
                  Object.keys(localizations).length !== 0 && Object
                          .entries(localizations)
                          .map(([key, langs]) => <LocalizationItem
                              key={key}
                              langKey={key}
                              langs={langs}
                              langMap={this.props.langMap}
                              activeUpdatingItem={this.state.activeUpdatingItem}
                              onSubmit={this.onLocalizationItemSubmit}
                              onReset={this.onLocalizationItemReset}
                          />)
                  }
                </div>
                {local_search.length !== 0 && !loading && Object.keys(localizations).length === 0 && (
                    <div className="lists-wrap__empty">
                      <div className="lists-wrap__empty-text">
                        По вашему запросу ничего не найдено
                      </div>
                    </div>
                )}
              </div>
              <div className="lists-footer">
                {
                  Object.keys(localizations).length !== 0 && (
                      <PaginationBlock
                          activePage={local_activePage}
                          pagesCount={pagesCount}
                          pagesVisible={7}
                          onChangePage={onChangePage}
                          displayOptions={[15, 30, 60, 120]}
                          selectedDisplayOption={local_limit}
                          selectDisplayOption={onChangeDisplayOption}
                      />
                  )
                }
              </div>
          </React.Fragment>
        }
        {loading && <Spinner />}
        <Modal
            heading="Вы действительно хотите изменить значение ключа"
            confirmText="Изменить"
            cancelText="Отмена"
            modal={changeLocaleModal}
            loading={loadingChange}
            onSubmit={this.onChangeLocalModalSubmit}
            onCancel={() => closeChangeLocaleModal()}
        />
      </div>
    );
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(LocalizationsList));
